import { StandardRedeem } from './StandardRedeem';
import { FastRedeem } from './FastRedeem';
import { StandardRedeemContext } from './StandardRedeemContext';
import { TextOutput } from './TextOutput';
import { DailyRedeemLimit } from './DailyRedeemLimit';

export const Redeem = {
  StandardRedeem,
  FastRedeem,
  StandardRedeemContext,
  TextOutput,
  DailyRedeemLimit,
};
